import { styled } from "@mui/material";
import { HiOutlineLocationMarker } from "react-icons/hi";

export const Title = styled("span")(() => ({
  fontSize: "16px",
  fontWeight: 700,
  color: "#465869",
  lineHeight: "24px",
  fontFamily: "Manrope",
}));

export const LocationIcon = styled(HiOutlineLocationMarker)(() => ({
  marginRight: "6px",
  color: "#475467",
}));
